import React, { useEffect, useRef, useState } from "react";
import NavBar from "../../../../Components/Navbar/navbar";
import styles from "../../../Styles/edit.module.css";
import { HiEye, HiEyeOff, HiMenu, HiMinusCircle, HiOutlineStar, HiPlusCircle, HiSearch, HiStar, HiX } from "react-icons/hi";
import { useLocation, useNavigate, useParams } from "react-router";
import axios from "axios";
import { getUser, Url, UrlAFACARD } from "../../../../Constants/globals";
import RefreshToken from "../../../../Components/RefreshToken/RefreshToken";
import Dropdown from "../../../../Components/Dropdown/dropdown";
import GoBack from "../../../../Components/GoBack/goback";
import stylesModal from "../../../../Components/DeleteModal/deletemodal.module.css";
import Loading from "../../../../Components/Loading/loading";
import Alert from "../../../../Components/Alert/alert";
import QRDownload from "../../../../Components/QRCode/QRCode";

async function deleteNewInfo(id, cardId) {
    try {
        await axios.delete(`${UrlAFACARD}/cards/${cardId}/links/${id}`, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Informação eliminada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await deleteNewInfo(id, cardId);
            else window.location.reload();
        }
        else {
            console.error(err);
            return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao eliminar a informação"}</Alert>];
        }
    };
}

async function patchPrimaryContact(id, cardId) {
    try {
        await axios.patch(`${UrlAFACARD}/cards/${cardId}/links/${id}`, {
            is_primary: true
        }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [200, <Alert type={"success"}>Contacto principal alterado com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await patchPrimaryContact(id, cardId);
            else window.location.reload();
        }
        else {
            console.error(err);
            return [0, <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao definir o contacto principal"}</Alert>];
        }
    };
}

async function addNewInfo(cardId, type, value, customHandle) {
    if (!customHandle) return ["", <Alert type={"error"}>{`Indique o nome do campo`}</Alert>];
    if (!value) return ["", <Alert type={"error"}>{`Indique o valor do campo ${customHandle}`}</Alert>];

    try {
        const response = await axios.post(`${UrlAFACARD}/cards/${cardId}/links`,
            {
                link_type_id: type.id,
                label_override: customHandle,
                value: value
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Informação adicionada com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addNewInfo(cardId, type, value, customHandle);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar a informação"}</Alert>];
        }
    };
}

async function addCard(user, name, company, cargo, departamento) {
    if (!user || !company) return ["", <Alert type={"error"}>Os campos colaborador, nome e empresa são obrigatórios</Alert>];
    try {
        const response = await axios.post(`${UrlAFACARD}/cards`,
            {
                full_name: user.full_name,
                card_holder: name,
                job_title: cargo,
                department: departamento,
                user_id: `${user.id}`,
                company_id: company.id
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Cartão adicionado com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await addCard(user, name, company, cargo, departamento);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o cartão");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao adicionar o cartão"}</Alert>];
        }
    };
}

async function editCard(cardId, name, cargo, departamento, contact, companyLinks) {
    if (!name) return ["", <Alert type={"error"}>Os campos nome, colaborador e empresa são obrigatórios</Alert>];
    try {
        const response = await axios.patch(`${UrlAFACARD}/cards/${cardId}`,
            {
                card_holder: name,
                job_title: cargo,
                department: departamento,
                hidden_company_link_ids: companyLinks?.length ? companyLinks.filter(c => c.dont_show).map(c => c.id) : []
            }, {
            headers: {
                Authorization: "Bearer " + getUser().token,
            },
        });
        return [response.data, <Alert type={"success"}>Cartão editado com sucesso!</Alert>];
    }
    catch (err) {
        if (err.request && err.request.status === 401) {
            var newToken = await RefreshToken(err);
            if (newToken) return await editCard(cardId, name, cargo, departamento, contact, companyLinks);
            else window.location.reload();
        }
        else {
            console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o cartão");
            return ["", <Alert type={"error"}>{err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao editar o cartão"}</Alert>];
        }
    };
}

function ModalAddCard({ closeModal, setSelected, setContacto, setName }) {

    const [searchName, setSearchName] = useState("");
    const [isPoppedOut, setIsPoppedOut] = useState(false);
    const [employees, setEmployees] = useState([]);

    async function chooseUser(u) {
        setSelected(u);
        if (u.phone) setContacto(`+351${u.phone}`);
        if (u.first_name && u.last_name) setName(`${u.first_name} ${u.last_name}`);
        handleClose();
    }

    async function fetchEmployees(page, nome) {
        try {
            const res = await axios.get(`${Url}/employees?per_page=12&page=${page ? page : 1}${nome ? `&nome=${nome}` : ""}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                }
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchEmployees(page, nome);
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function getEmployees() {
        const empData = await fetchEmployees(1, searchName);
        if (empData) {
            setEmployees(empData.users ? empData.users : []);
        }
    }

    function handleClose() {
        setIsPoppedOut(true);
        setTimeout(() => {
            closeModal("");
        }, 250);
    }

    return (
        <div className={`${stylesModal.bodyDelete} ${isPoppedOut ? stylesModal.popout : stylesModal.popin}`}>
            <div className={stylesModal.center}>
                <div className={stylesModal.column}>
                    <h2 style={{ marginTop: 0 }}>
                        Selecionar colaborador
                    </h2>
                    <div className={styles.formBlockSection}>
                        <input
                            type="text"
                            placeholder="Procurar colaborador"
                            value={searchName}
                            onChange={(e) => setSearchName(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") { getEmployees() } }}
                        />
                        <button
                            style={{ marginLeft: "0" }}
                            className={styles.btnSearch}
                            onClick={() => getEmployees()}
                        >
                            <HiSearch size={18} />
                        </button>
                    </div>
                    <div style={{ marginTop: "20px" }} className={styles.chooseCardUsers}>
                        {
                            employees?.length ?
                                employees.map((u, index) =>
                                    <div key={index} className={styles.chooseCardUser} onClick={() => chooseUser(u)}>
                                        {u.full_name} (<i>{u.num}</i>)
                                    </div>
                                )
                                : ""
                        }
                    </div>
                    <div className={stylesModal.buttons}>
                        <button className={stylesModal.backButton} onClick={() => handleClose()}>Regressar</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

function EditarCartoes({ userPermissions }) {

    const { id } = useParams();
    const location = useLocation();
    const { state } = location;
    const navigate = useNavigate();
    const newInfoRef = useRef();
    const dragItem = useRef(null);
    const dragOverItem = useRef(null);

    const [modalAddCard, setModalAddCard] = useState("");
    const [alert, setAlert] = useState("");
    const [loading, setLoading] = useState("");
    const [loadingData, setLoadingData] = useState(true);
    const [companies, setCompanies] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState("");

    const [selectedColaborador, setSelectedColaborador] = useState("");
    const [userName, setUserName] = useState("");

    const [cargo, setCargo] = useState("");
    const [departamento, setDepartamento] = useState("");
    const [contacto, setContacto] = useState("");
    const [slug, setSlug] = useState("");

    const [emailWallet, setEmailWallet] = useState("");

    const [foregroundColor, setForegroundColor] = useState("");
    const [backgroundColor, setBackgroundColor] = useState("");
    const [textColor, setTextColor] = useState("");
    const [logoUrl, setLogoUrl] = useState("");

    const [dragOverIndex, setDragOverIndex] = useState(null);

    const [addInfo, setAddInfo] = useState(false);

    const [newInfo, setNewInfo] = useState("");
    const [newInfoHandle, setNewInfoHandle] = useState("");
    const [infoTypes, setInfoTypes] = useState([]);
    const [selectedInfoType, setSelectedInfoType] = useState("");

    const [info, setInfo] = useState([]);

    async function fetchCompanies() {
        try {
            const res = await axios.get(`${UrlAFACARD}/companies`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchCompanies();
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function fetchInfoTypes() {
        try {
            const res = await axios.get(`${UrlAFACARD}/link-types`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchInfoTypes();
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function fetchDetails() {
        try {
            const res = await axios.get(`${UrlAFACARD}/cards/${id}`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchDetails();
                else window.location.reload();
            }
            else {
                console.error(err);
                return "";
            }
        };
    }

    async function assignData() {
        const companiesData = await fetchCompanies();
        setCompanies(companiesData?.items?.length ? companiesData.items : []);
        if (id) {
            const results = await Promise.all([fetchDetails(), fetchInfoTypes()]);
            const [detailsData, infoTypesData] = results;

            setInfoTypes(infoTypesData?.items?.length ? infoTypesData.items : []);

            if (detailsData) {
                await getInfo(id, detailsData.user);
                setSlug(detailsData.slug);
                setContacto(detailsData.contact);
                setCargo(detailsData.job_title);
                setDepartamento(detailsData.department);
                setSelectedCompany(
                    detailsData.hidden_company_link_ids ?
                        {
                            ...detailsData.company,
                            links: detailsData.company.links.map(a =>
                                detailsData.hidden_company_link_ids.includes(a.id)
                                    ? { ...a, dont_show: true }
                                    : { ...a, dont_show: false }
                            )
                        }
                        : {
                            ...detailsData.company,
                            links: detailsData.company.links?.map(a => ({ ...a, dont_show: false }))
                        }
                );
                setSelectedColaborador(detailsData.user);
                setUserName(detailsData.card_holder ? detailsData.card_holder : "");
            }
            else navigate("/cartoes");
        }
        setLoadingData(false);
    }

    useEffect(() => {
        setForegroundColor(selectedCompany?.primary_color ?? "");
        setBackgroundColor(selectedCompany?.secondary_color ?? "");
        setTextColor(selectedCompany?.text_color ?? "");
        setLogoUrl(selectedCompany?.logo_url);
    }, [selectedCompany]);

    useEffect(() => {
        assignData();
    }, [id]);

    async function fetchInfo(thisId) {
        try {
            const res = await axios.get(`${UrlAFACARD}/cards/${thisId}/links`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return res.data;
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await fetchInfo(thisId);
                else window.location.reload();
            }
            else {
                console.error(err);
                return [];
            }
        };
    }

    async function getInfo(thisId) {
        const infoData = await fetchInfo(thisId);
        setInfo(infoData);
    }

    async function getAlertAddInfo() {
        await setAlert("");
        const res = await addNewInfo(id, selectedInfoType, newInfo, newInfoHandle);
        setAlert(res[1]);
        getInfo(id);
    }

    async function getAlertDelete(infoId) {
        await setAlert("");
        const res = await deleteNewInfo(infoId, id);
        setAlert(res[1]);
        getInfo(id);
    }

    async function turnPrimaryContact(infoId) {
        await setAlert("");
        const res = await patchPrimaryContact(infoId, id);
        setAlert(res[1]);
        getInfo(id);
    }

    async function getAlertAdd() {
        await setLoading(<Loading />);
        await setAlert("");
        const res = await addCard(selectedColaborador, userName, selectedCompany, cargo, departamento);
        setLoading("");
        if (res[0]) {
            navigate(`/cartoes/${res[0].id}`);
        }
        else setAlert(res[1]);
    }

    async function getAlertEdit() {
        await setLoading(<Loading />);
        await setAlert("");
        const res = await editCard(id, userName, cargo, departamento, contacto, selectedCompany?.links?.length ? selectedCompany.links : []);
        setLoading("");
        setAlert(res[1]);
    }

    useEffect(() => {
        setNewInfoHandle(selectedInfoType.label ? selectedInfoType.label : "");
        setNewInfo(selectedInfoType.default_value ? selectedInfoType.default_value : "");
        if (newInfoRef?.current) newInfoRef.current.focus();
    }, [selectedInfoType]);

    function handleDeleteCompanyLink(link_id) {
        setSelectedCompany(prev => ({
            ...prev,
            links: prev.links.map(a =>
                a.id === link_id ? { ...a, dont_show: a.dont_show ? false : true } : a
            )
        }));
    }

    async function changeFieldPosition(link_id, new_position) {
        try {
            await axios.patch(`${UrlAFACARD}/cards/${id}/links/${link_id}/reorder`,
                { new_position }, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
            });
            return getInfo(id);
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await changeFieldPosition(link_id, new_position);
                else window.location.reload();
            }
            else {
                console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao alterar a ordenação dos campos");
            }
        }
    }

    function handleDragStart(index) {
        dragItem.current = index;
    }

    function handleDragEnter(index) {
        dragOverItem.current = index;
        setDragOverIndex(index);
    }

    async function handleDragEnd() {
        const from = dragItem.current;
        const to = dragOverItem.current;
        setDragOverIndex(null);
        if (from === null || to === null || from === to) {
            dragItem.current = null;
            dragOverItem.current = null;
            return;
        }
        const newInfo = [...info];
        const [moved] = newInfo.splice(from, 1);
        newInfo.splice(to, 0, moved);
        setInfo(newInfo);
        dragItem.current = null;
        dragOverItem.current = null;
        await changeFieldPosition(moved.id, to);
    }

    function checkEmail(inf) {
        for (const i of inf) {
            if (i.link_type?.slug?.includes("email")) {
                return (
                    <p style={{ margin: "3px 0 0 0", fontSize: "10pt", color: textColor }}>
                        {i.value}
                    </p>
                );
            }
        }
    }

    async function downloadQR(filename) {
        try {
            const res = await axios.get(`${UrlAFACARD}/cards/${id}/qr/dynamic`, {
                headers: {
                    Authorization: "Bearer " + getUser().token,
                },
                responseType: "arraybuffer"
            });
            const blob = new Blob([res.data]);
            const qrUrl = URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = qrUrl;
            link.setAttribute('download', filename ? `${filename}-${Date.now()}.png` : `qrcode-${Date.now()}.png`);
            document.body.appendChild(link);
            link.click();
            return setAlert(<Alert type={"success"}>QR Code descarregado com sucesso</Alert>);
        }
        catch (err) {
            if (err.request && err.request.status === 401) {
                var newToken = await RefreshToken(err);
                if (newToken) return await downloadQR(filename);
                else window.location.reload();
            }
            else {
                console.error(err?.response?.data?.detail && (typeof err.response.data.detail === "string") ? err.response.data.detail : "Ocorreu um erro ao gerar o QR Code");
                return setAlert(<Alert type={"error"}>Ocorreu um erro ao gerar o QR Code</Alert>);
            }
        };
    }

    return (
        <div className="body">
            {alert}
            {loading}
            {modalAddCard}
            <NavBar current={"colaboradores"} setDisappear={setLoadingData} userPermissions={userPermissions} />
            {
                loadingData ? ""
                    :
                    <div className={styles.content}>
                        <GoBack backRoute={`/cartoes`} backState={state?.page ? { page: state.page, nomeSearch: state.nomeSearch ?? "" } : {}} />
                        <h1 className={styles.backgroundName}>
                            {
                                id ? "Editar cartão" : "Adicionar cartão"
                            }
                        </h1>
                        <div className={styles.formBlockSection} style={{ marginBottom: "2rem", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", backgroundColor: "transparent", padding: 0 }}>
                            {
                                selectedCompany ?
                                    <div style={{ boxShadow: "0 0 5px 3px #00000020", overflow: "hidden", borderRadius: "14px" }}>
                                        <div style={{ backgroundColor: backgroundColor }} className={styles.secondColor}>
                                            {
                                                logoUrl ?
                                                    <img src={`${UrlAFACARD}/${logoUrl}`} className={styles.companyLogo2} alt="logo" />
                                                    : ""
                                            }
                                        </div>
                                        <div style={{ backgroundColor: foregroundColor }} className={styles.firstColor}>
                                            <div style={{ padding: "24px 20px 18px 20px" }}>
                                                <p style={{ margin: 0, fontSize: "12pt", color: textColor, fontWeight: "600" }}>
                                                    {userName}
                                                </p>
                                                <p style={{ margin: "6px 0 0 0", fontSize: "10pt", color: textColor }}>
                                                    {cargo}
                                                </p>
                                                <p style={{ margin: "3px 0 0 0", fontSize: "10pt", color: textColor }}>
                                                    {departamento}
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <div className={styles.cardPlaceholder}>
                                        Escolha a empresa
                                    </div>
                            }
                        </div>
                        <div className={styles.formBlock} style={{ placeItems: "center" }}>
                            {
                                id ?
                                    <div className={styles.formBlockSection} style={{ width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 }}>
                                        <p style={{ whiteSpace: "nowrap" }}>
                                            Link QR Code:
                                        </p>
                                        <input
                                            disabled
                                            value={`${UrlAFACARD}/c/${slug}/vcf`}
                                        />
                                        <button
                                            className={styles.textButton}
                                            onClick={async () => {
                                                await setAlert("");
                                                navigator.clipboard.writeText(`${UrlAFACARD}/c/${slug}/vcf`);
                                                setAlert(<Alert type="success">Link copiado</Alert>)
                                            }}
                                        >
                                            Copiar
                                        </button>
                                        <button
                                            style={{ marginRight: "10px", whiteSpace: "nowrap" }}
                                            className={styles.textButton}
                                            onClick={() => downloadQR(userName)}
                                        >
                                            Download QR Code
                                        </button>
                                    </div>
                                    : ""
                            }
                            <div
                                style={id ? { opacity: 0.6, cursor: "not-allowed", width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 } : { width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 }}
                                className={styles.formBlockSectionButton}
                                onClick={() => !id && setModalAddCard(
                                    <ModalAddCard
                                        closeModal={setModalAddCard}
                                        setAlert={setAlert}
                                        setLoading={setLoading}
                                        setSelected={setSelectedColaborador}
                                        setContacto={setContacto}
                                        setName={setUserName}
                                    />
                                )}
                            >
                                <p style={{ margin: 0, padding: "1rem" }}>
                                    {
                                        selectedColaborador ?
                                            selectedColaborador.full_name
                                            :
                                            "Selecionar colaborador"
                                    }
                                </p>
                            </div>
                            <div className={styles.formBlockSection} style={{ width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 }}>
                                <p>
                                    Nome:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setUserName(e.target.value)}
                                    value={userName}
                                />
                            </div>
                            <div className={styles.formBlockSection} style={{ width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 }}>
                                <p>
                                    Cargo:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setCargo(e.target.value)}
                                    value={cargo}
                                />
                            </div>
                            <div className={styles.formBlockSection} style={{ width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 }}>
                                <p>
                                    Departamento:
                                </p>
                                <input
                                    type="text"
                                    onChange={(e) => setDepartamento(e.target.value)}
                                    value={departamento}
                                />
                            </div>
                        </div>
                        <>
                            <h3 style={{ textAlign: "center" }}>
                                Informações da empresa
                            </h3>

                            <div style={{ marginBottom: "1rem", placeItems: "center" }} className={styles.formBlock}>
                                <div style={{ width: "calc(50% - 1rem)", gridColumnStart: 1, gridColumnEnd: 4 }}>
                                    <Dropdown
                                        disabled={id}
                                        label={"Empresa:"}
                                        placeholder={"Escolher empresa"}
                                        items={companies}
                                        value={selectedCompany}
                                        onValueChange={setSelectedCompany}
                                    />
                                </div>
                                {
                                    selectedCompany?.links?.length ?
                                        selectedCompany.links.map((i, index) =>
                                            <div
                                                key={index}
                                                className={styles.formBlockSection}
                                                style={{ width: "calc(50% - 2rem)", gridColumnStart: 1, gridColumnEnd: 4 }}
                                            >
                                                <p style={{ whiteSpace: "nowrap" }}>
                                                    {i.label_override ? i.label_override : i.link_type?.label ? i.link_type.label : ""}:
                                                </p>
                                                <input disabled type="text" value={i.value} />
                                                {
                                                    id ?
                                                        i.dont_show ?
                                                            <HiEyeOff
                                                                title="Encontra-se escondido"
                                                                style={{ marginRight: "8px", cursor: "pointer" }}
                                                                color="red"
                                                                onClick={() => handleDeleteCompanyLink(i.id)}
                                                            />
                                                            :
                                                            <HiEye
                                                                title="Encontra-se a aparecer"
                                                                style={{ marginRight: "8px", cursor: "pointer" }}
                                                                onClick={() => handleDeleteCompanyLink(i.id)}
                                                            />
                                                        : ""
                                                }
                                            </div>
                                        )
                                        : ""
                                }
                            </div>
                            {
                                id ?
                                    <h3 style={{ display: "flex", justifyContent: "center", alignItems: "center", gap: "6px" }}>
                                        Outras informações
                                        {
                                            addInfo ?
                                                <HiMinusCircle
                                                    className={styles.icon}
                                                    onClick={() => setAddInfo(false)}
                                                />
                                                :
                                                <HiPlusCircle
                                                    className={styles.icon}
                                                    onClick={() => setAddInfo(true)}
                                                />
                                        }
                                    </h3>
                                    : ""
                            }
                            {
                                addInfo ?
                                    <div className={styles.formBlock} style={{ marginBottom: "2rem" }}>
                                        <Dropdown
                                            label={"Tipo:"}
                                            placeholder={"Escolher tipo de informação"}
                                            valueLabel="display_name"
                                            items={infoTypes}
                                            value={selectedInfoType}
                                            onValueChange={setSelectedInfoType}
                                        />
                                        {
                                            selectedInfoType ?
                                                <div className={styles.formBlockSection}>
                                                    <input
                                                        style={{ backgroundColor: "var(--background)", width: "200px" }}
                                                        type="text"
                                                        placeholder="Nome do campo"
                                                        value={newInfoHandle}
                                                        onChange={(e) => setNewInfoHandle(e.target.value)}
                                                    />
                                                    <input
                                                        ref={newInfoRef}
                                                        type="text"
                                                        placeholder="Valor"
                                                        value={newInfo}
                                                        onChange={(e) => setNewInfo(e.target.value)}
                                                    />
                                                    <button
                                                        className={styles.btnFileType}
                                                        style={{ width: "160px", marginRight: "8px", backgroundColor: "var(--hoverItem)" }}
                                                        onClick={() => getAlertAddInfo()}
                                                    >
                                                        Adicionar
                                                    </button>
                                                </div>
                                                :
                                                <div></div>
                                        }
                                    </div>
                                    : ""
                            }

                            <div style={{ marginBottom: "1rem", placeItems: "center" }} className={styles.formBlock}>
                                {
                                    info?.length ?
                                        info.map((i, index) =>
                                            <div
                                                key={i.id}
                                                className={styles.formBlockSection}
                                                draggable
                                                onDragStart={() => handleDragStart(index)}
                                                onDragEnter={() => handleDragEnter(index)}
                                                onDragEnd={handleDragEnd}
                                                onDragOver={(e) => e.preventDefault()}
                                                style={{
                                                    width: "calc(50% - 2rem)",
                                                    gridColumnStart: 1,
                                                    gridColumnEnd: 4,
                                                    opacity: dragItem.current === index ? 0.4 : 1,
                                                    border: dragOverIndex === index && dragItem.current !== index
                                                        ? "2px dashed var(--buttonBackground)"
                                                        : "2px solid transparent",
                                                    transition: "border 0.15s ease, opacity 0.15s ease",
                                                    cursor: "grab"
                                                }}
                                            >
                                                <HiMenu
                                                    size={18}
                                                    style={{ flexShrink: 0, color: "var(--placeholder, #aaa)", cursor: "grab" }}
                                                    title="Arrastar para reordenar"
                                                />
                                                <p style={{ whiteSpace: "nowrap" }}>
                                                    {i.label_override ? i.label_override : i.link_type?.display_name ? i.link_type.display_name : ""}:
                                                </p>
                                                <input disabled type="text" value={i.value} />
                                                <div style={{ display: "flex" }}>
                                                    {
                                                        i.link_type?.slug?.includes("phone") && i.is_primary ?
                                                            <HiStar color="var(--afaGold)" title="Contacto principal a ser partilhado" size={14} style={{ padding: "4px", minWidth: "14px", marginRight: "8px", cursor: "pointer", flexShrink: 0 }} onClick={() => turnPrimaryContact(i.id)} />
                                                            : i.link_type?.slug?.includes("phone") ?
                                                                <HiOutlineStar color="var(--afaGold)" title="Tornar contacto principal a ser partilhado" size={14} style={{ padding: "4px", minWidth: "14px", marginRight: "8px", cursor: "pointer", flexShrink: 0 }} onClick={() => turnPrimaryContact(i.id)} />
                                                                : ""
                                                    }
                                                    <HiX size={14} style={{ padding: "4px", minWidth: "14px", marginRight: "8px", cursor: "pointer", flexShrink: 0 }} color="red" onClick={() => getAlertDelete(i.id)} />
                                                </div>
                                            </div>
                                        )
                                        : ""
                                }
                            </div>
                        </>
                        {
                            id ?
                                <div>
                                    <button className={styles.btn} onClick={() => getAlertEdit()}>
                                        Guardar alterações
                                    </button>
                                </div>
                                :
                                <button className={styles.btn} onClick={() => getAlertAdd()}>
                                    Adicionar cartão
                                </button>
                        }
                    </div>
            }
        </div>
    );
}

export default EditarCartoes;